import { render, staticRenderFns } from "./literature.vue?vue&type=template&id=b4e81212&scoped=true&"
import script from "./literature.vue?vue&type=script&lang=js&"
export * from "./literature.vue?vue&type=script&lang=js&"
import style0 from "./literature.vue?vue&type=style&index=0&id=b4e81212&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e81212",
  null
  
)

export default component.exports